import { request } from '@umijs/max';

export async function queryIntroductionById(
  id: number,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/introduction/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateIntroduction(
  id: number,
  body: any,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/introduction/${id}`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}
